/** @format */
import { CourseUnit } from 'common-typescript/types';
import { SelectableStudy } from './select-course-units-modal/types';
import { CodedTimelineItem } from './timeline/study-period-data.service';

/**
 * Orders non-empty before empty.
 */
function stringCompare(a: string | null, b: string | null): number {
    if (!a) {
        return b ? 1 : 0;
    }

    if (!b) {
        return -1;
    }

    return a.localeCompare(b);
}

export function sortByCuCode(selectableStudies: SelectableStudy[]): SelectableStudy[] {
    return selectableStudies.sort((a, b) => {
        const codeA = codeOrNull(a);
        const codeB = codeOrNull(b);
        const codeComparison: number = stringCompare(codeA, codeB);
        return codeComparison === 0 ? stringCompare(a.value.value.id, b.value.value.id) : codeComparison;
    });
}

export function sortTimelineItems(codedTimelineItems: CodedTimelineItem[]): CodedTimelineItem[] {
    return codedTimelineItems.sort((a, b) => {
        const codeComparison: number = stringCompare(a.code, b.code);
        return codeComparison === 0
            ? stringCompare(a.id, b.id) // tiebreaker
            : codeComparison;
    });
}

function codeOrNull(study: SelectableStudy): string | null {
    if (study.value.type === 'CourseUnit') {
        return (study.value.value as CourseUnit).code;
    }
    return null;
}
